import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'multiKeyFilter'
})

export class MultiKeyFilterPipe implements PipeTransform {

  transform(value: any[], searchTerm: string, keys: string[]): any[] {
    if (!value || !searchTerm || !keys || keys.length === 0) {
      return value;
    }

    // Filter logic: iterate over the array and check each key
    return value.filter(item => 
      keys.some(key => 
        item[key]?.toString().toLowerCase().includes(searchTerm.toLowerCase())
      )
    );
  }
}
